/**
 * (c) 2022, Nous Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
const Container = {
  variants: {
    "sidebar-header": {
      bg: "hsla(221, 100%, 59%, 1)",
      p: 0,
      maxW: "unset",
    },
  },
};

export default Container;
